module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-lista"
  }, [(_vm.iframe) ? _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "iframe",
    domProps: {
      "innerHTML": _vm._s(_vm.iframe)
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "display-flex fdr space-evenly margin-top-10"
  }, [(!_vm.estado) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.acabarClase
    }
  }, [_vm._v("Terminar")]) : _vm._e(), (!_vm.esUltimaClase) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.acabarClase
    }
  }, [_vm._v("Siguiente")]) : _vm._e()]), _c('div', {
    staticClass: "contenedor-glosa"
  }, [_c('strong', {
    staticClass: "titulo"
  }, [_vm._v(_vm._s(_vm.titulo))]), _c('br'), _c('P', {
    staticClass: "pt-10 descripcion",
    domProps: {
      "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(_vm.descripcion))
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37e34fae","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_cursos_virtuales_video.vue
// module id = 863
// module chunks = 0